export enum BasePath {
    HOME = '/',
    TRADE = '/trade',
    POOLS = '/pools',
    REFERRALS = '/referrals',
    ANALYTICS = '/analytics',
    LEADERBOARD = '/leaderboard',
}
